import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'components/Box';
import InlineList from 'components/InlineList';
import Disclosure from 'components/Disclosure';
import TagPill from 'components/Pill/PillVariants/TagPill';
import Text from 'components/Text';
import UserGeneratedText from 'components/UserGeneratedText';
function InfoSection(_ref) {
  var _ref$description = _ref.description,
    description = _ref$description === void 0 ? '' : _ref$description,
    _ref$tags = _ref.tags,
    tags = _ref$tags === void 0 ? [] : _ref$tags;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var hasTags = tags.length !== 0;
  var hasInfoSection = description || hasTags;
  if (!hasInfoSection) return null;
  return /*#__PURE__*/React.createElement(Disclosure.Provider, null, /*#__PURE__*/React.createElement(Disclosure.Toggle, {
    mt: "m"
  }, t('asset_viewer_info')), /*#__PURE__*/React.createElement(Disclosure.Hidden, {
    fontSize: "s"
  }, description && /*#__PURE__*/React.createElement(UserGeneratedText, {
    text: description
  }), hasTags && /*#__PURE__*/React.createElement(Box, {
    mt: "s"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "strong",
    display: "block",
    mb: "xxs"
  }, t('content_type_tag_plural'), ":"), /*#__PURE__*/React.createElement(InlineList, {
    spacing: "xxs"
  }, tags.map(function (tag, index) {
    return /*#__PURE__*/React.createElement(TagPill, {
      key: tag.id || index,
      link: tag.location
    }, tag.title);
  })))));
}
export default InfoSection;